import { AppLocalizationKey, TechtimePayload } from '~/common/types/types';
import { generateItems } from '~/helpers/helpers';
import { teamCompositionPayload } from '~/components/main-page/data/data';

const TIMELINE_ITEMS_COUNT = 14;

const techtimePayload: TechtimePayload = {
  title: 'technology.js.techtime.title',
  videoLecturesCount: 'technology.js.techtime.videoLecturesCount',
  projectEnvironmentTitle: 'technology.js.techtime.projectEnvironmentTitle',
  blocks: {
    lectures: {
      title: `technology.js.techtime.group${0}.title` as AppLocalizationKey,
      period: `technology.js.techtime.group${0}.period` as AppLocalizationKey,
      description:
        `technology.js.techtime.group${0}.description` as AppLocalizationKey,
    },
    project: {
      title: `technology.js.techtime.group${1}.title` as AppLocalizationKey,
      period: `technology.js.techtime.group${1}.period` as AppLocalizationKey,
      description:
        `technology.js.techtime.group${1}.description` as AppLocalizationKey,
    },
  },
  timeline: generateItems(TIMELINE_ITEMS_COUNT, (idx) => ({
    label:
      `technology.js.techtime.timeline.lecture${idx}.label` as AppLocalizationKey,
    title:
      `technology.js.techtime.timeline.lecture${idx}.title` as AppLocalizationKey,
    startDate:
      `technology.js.techtime.timeline.lecture${idx}.startDate` as AppLocalizationKey,
  })),
  notice: 'technology.js.techtime.notice' as AppLocalizationKey,
  teamCompositionPayload: teamCompositionPayload,
};

export { techtimePayload };
